import { render, staticRenderFns } from "./StaffGroup.vue?vue&type=template&id=57c56f30&"
import script from "./StaffGroup.vue?vue&type=script&lang=js&"
export * from "./StaffGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports